// creating all factories here in a separate file is needed to get tree-shaking working
import * as allFactories from '../factoriesAny.js';
export var all = allFactories;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/allFactoriesAny.js
// module id = null
// module chunks = 